export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex justify-center lg:justify-end order-2 lg:order-1">
            <div className="relative w-[240px] h-[420px] sm:w-[280px] sm:h-[480px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20download%20page%20for%20a%20video%20streaming%20app%20with%20download%20buttons%20and%20version%20info%2C%20clean%20minimal%20UI%20design%20with%20warm%20coral%20accents%2C%20placed%20on%20a%20light%20surface%2C%20soft%20natural%20lighting%2C%20modern%20app%20showcase%20photography&width=560&height=960&seq=app-download-phone&orientation=portrait"
                alt="91免费看片app下载页面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wide text-accent-800 bg-accent-100 rounded-full mb-5">
              全平台客户端下载
            </span>

            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">移动客户端</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
              91免费看片的app现已覆盖Android、iOS、Windows和Mac四大平台。
              扫描二维码或点击下方按钮，即刻下载91免费客户端，
              开启流畅高清的免费看片体验。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 border border-background-200/70 min-w-[120px]">
                <i className="ri-android-line text-2xl text-primary-600"></i>
                <span className="text-xs font-semibold text-foreground-900">Android 版</span>
                <span className="text-[10px] text-foreground-400">V8.2.1 · 28MB</span>
                <span className="px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md cursor-pointer">下载</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 border border-background-200/70 min-w-[120px]">
                <i className="ri-apple-line text-2xl text-primary-600"></i>
                <span className="text-xs font-semibold text-foreground-900">iOS 版</span>
                <span className="text-[10px] text-foreground-400">V8.2.0 · 32MB</span>
                <span className="px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md cursor-pointer">下载</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 border border-background-200/70 min-w-[120px]">
                <i className="ri-computer-line text-2xl text-primary-600"></i>
                <span className="text-xs font-semibold text-foreground-900">PC 版</span>
                <span className="text-[10px] text-foreground-400">Win/Mac</span>
                <span className="px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md cursor-pointer">下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}